module.exports = __webpack_public_path__ + "img/四川天府新区（成南幼儿园）.b17e286a.jpg";